import { get } from 'tools/request'
import { Div } from 'alkali'
import './covid.scss'

global.launchCovid = async () => {
	let stats = await get('/portal/covid-stats')
	let questionNames = ['Dexamethasone-Mortality', 'Remdesivir-Mortality']
	let i = 0
	for (let li of document.querySelectorAll('#covid-questions-list li')) {
		let count = stats[questionNames[i]]
		li.append(Div('.covid-question-stat', [
			Div('.covid-question-bar', {
				width: (count + 1) + 'em',
			}, [ count + '' ]),
		]))
		i++
	}
}